// extracted by mini-css-extract-plugin
export default {"wrapper":"CookieNotice_wrapper__eM8ql","actions":"CookieNotice_actions__o-yvE"};